$(document).ready(function(){
  function product_image_slider(){
    $('.custom_product_slideshow').slick({
      arrows:false,
      infinite: false,
      dots:false,
      asNavFor: '.product__thumbs_custom',
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            dots:true,
            adaptiveHeight: true
          }
        }
      ]
    });
    $('.product__thumbs_custom').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.custom_product_slideshow',
      arrows:true,
      dots:false,
      vertical:true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    });
    setTimeout(function(){
      var main_slide_height = $('.custom_product_slideshow .product_image_gi').height();
      console.log('main_slide_height '+main_slide_height);
      $('.product__thumbs_custom  .slick-list').height(main_slide_height);
    },1000);
  }
  function customzoom(){
    $(document).on('click','.js-photoswipe__zoom',function(){
      var pswpElement = document.querySelectorAll('.pswp')[0];
      var items = [];
      var options = {};

      $('.custom_product_slideshow img').each(function(){
        var item = {
          src: $(this).attr('data-photoswipe-src'),
          w:  $(this).attr('data-photoswipe-width'),
          h:  $(this).attr('data-photoswipe-height'),
          el:  $(this),
          initialZoomLevel: 0.5
        }

        items.push(item);
      });
      options = {
        allowPanToNext: false,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        pinchToClose: false,
        preloaderEl: false,
        scaleMode: 'zoom',
        shareEl: false,
        tapToToggleControls: false
      }
      console.log('items ',items);
      console.log('options ',options);
      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    });
  }
  product_image_slider();
  customzoom();

  $(document).on('click','.product__thumbs_custom img',function(e) {
    e.preventDefault();
    $('.product__thumbs_custom .product_thumb_gi').removeClass('active');
    $(this).parents('.product_thumb_gi').addClass('active');
    var slideno = $(this).data('slide');
    $('.custom_product_slideshow').slick('slickGoTo', slideno - 1);
  });
  $('.variant-input-wrap input').change(function(){
    setTimeout(function(){
      $('.variant-input-wrap .variant-input label').show();
      $(this).parents('.product-block').find('label.disabled').hide();
      var pro_v_url = window.location.href;
      console.log('pro_v_url '+pro_v_url);
      $.ajax({
        type: 'GET', 
        url: pro_v_url,
        dataType: 'html', 
        success:function(vhtml){
          //console.log('vhtml '+vhtml);
          var variant_image_html = $(vhtml).find('.custom_product_wrap').html();
          $('.custom_product_wrap').html(variant_image_html);
          product_image_slider();
          customzoom();
        }
      });
    },10);
  });
  
  // Upsell functionlity 
  
  $('.variant-input-wrap .variant-input input').change(function(){
    var main_v_price = $('select.product-single__variants').find(':selected').data('price');
    var upsell_price  = $('.cus_uprice').data('price');
    var total_price = main_v_price + upsell_price;
    $('.cus_uprice').text('Rs. '+(total_price/100.00).toFixed(2));
  });
  
  $('fieldset.variant-input-wrap[name="Device"] .variant-input input').click(function(){
    var device_name = $(this).val();
    console.log('device_name',device_name)
    $('span.product--label_device').text(device_name);
    //console.log('device_name '+device_name);
  });
   $('fieldset.variant-input-wrap[name="Size"] .variant-input input').click(function(){
    var device_name = $(this).val();
    console.log('device_name',device_name)
    $('span.product--label_device').text(device_name);
    //console.log('device_name '+device_name);
  });
  $(document).on('click','.bundleWrapper input#upsell_productt',function(){
    console.log('status '+$(this).prop('checked'));
    if($(this).prop('checked') == true){
      jQuery(this).addClass('checked');
      var main_v_price = $('select.product-single__variants').find(':selected').data('price');
      var upsell_price  = $(this).parents('.customers-also-bought').find('.cus_uprice').data('price');
      var total_price = main_v_price + upsell_price;
      $(this).parents('.customers-also-bought').find('.cus_uprice').text('Rs. '+(total_price/100.00).toFixed(2));
     $(this).parents('.customers-also-bought').find('.ufe-total-price').removeClass('hide');
      $('.payment-buttons').hide();
      $('.c_payment_buttons').show();
      var upsell_status =$(this).data('status');
      if(upsell_status == false){
      $('.c_payment_buttons span').text('Sold Out');
      }else{
      $('.c_payment_buttons span').text('Add to Cart');
      }
    }else{
      jQuery(this).removeClass('checked');
      $(this).parents('.customers-also-bought').find('.ufe-total-price').addClass('hide');
      $('.c_payment_buttons').hide();
      $('.payment-buttons').show();
    }
  });
  
  $(document).on('click','.c_payment_buttons .bundle_add-to-cart',function(e){
    e.preventDefault();
    if($(this).hasClass('disabled') == false){
      var main_pro_vid = $('select.product-single__variants').find(':selected').val();
      var b_vid = [];
      b_vid.push(main_pro_vid);
      var upsell_id = $('.customers-also-bought.active .ufe-checkbox input#upsell_productt').data('val');
      b_vid.push(upsell_id);
      console.log('b_vid',b_vid);
      bundleAddtocart(b_vid);
    }
  });
  
  // show upsell according to variant
  jQuery(document).on('click','.variant-input-wrap .variant-input input',function(){
    setTimeout(function(){
      jQuery('.bundleWrapper input#upsell_productt').prop('checked', false);
      $('.c_payment_buttons').hide();
      $('.payment-buttons').show();
      $('.ufe-total-price').addClass('hide');
      var getSelectedId = jQuery('select.product-single__variants').find(':selected').data('vid');
      console.log('getSelectedId '+getSelectedId);
      jQuery('.customers-also-bought').addClass('hide');
      jQuery('.customers-also-bought').removeClass('active');
      jQuery('#upsell_'+getSelectedId).removeClass('hide');
      jQuery('#upsell_'+getSelectedId).addClass('active');
      
    },50);
  });
  
  function  bundleAddtocart(iddArr){
    var e_id = iddArr.shift();

    data = {
      "quantity": 1,
      "id": e_id
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        if(iddArr.length == 0){
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
        }
        else{
          bundleAddtocart(iddArr);
        }      
      },
      error: function (error) {      
        alert(error.responseJSON['description']);
      }
    });
  }
  
  
  $(document).on('change', '#SortByMobile', function(){
    console.log('dfhf', $('#SortBy').length)
    $('#SortBy').val($(this).val()).trigger('change');
  });
});